<script lang="ts">
  export const name = 'Stop';
  export let className = '';
</script>

<svg class={className} viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M8.61349 0.924316H1.67264C1.25935 0.924316 0.924316 1.25935 0.924316 1.67264V8.61349C0.924316 9.02678 1.25935 9.36182 1.67264 9.36182H8.61349C9.02678 9.36182 9.36182 9.02678 9.36182 8.61349V1.67264C9.36182 1.25935 9.02678 0.924316 8.61349 0.924316Z"
  />
</svg>
